export default __webpack_public_path__ + "static/media/desertia.5242c31b.webp";